import { useThemeMode } from "sandbox/contexts/ThemeModeContext";

const SANDBOX_LOGO_SRC = "/logo.png";
const SANDBOX_LOGO_DARK_SRC = "/whiteLogo.png";

export const useSandboxLogo = (): string => {
  const { mode } = useThemeMode();
  return mode === "dark" ? SANDBOX_LOGO_DARK_SRC : SANDBOX_LOGO_SRC;
};
